/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'header.applicationTitle': {
    id: 'header.applicationTitle',
    defaultMessage: 'Media Editing Widget Demo',
  },
  'header.documentation': {
    id: 'header.documentation',
    defaultMessage: 'Documentation',
  },
  'header.signUp': {
    id: 'header.signUp',
    defaultMessage: 'Sign Up For Free',
  },
  'section.general': {
    id: 'section.general',
    defaultMessage: 'General',
  },
  'section.general.reset': {
    id: 'section.general.reset',
    defaultMessage: 'Reset All To Default',
  },
  'section.general.customizeThisDemoTheme': {
    id: 'section.general.customizeThisDemoTheme',
    defaultMessage: 'Customize this demo theme',
  },
  'section.lookAndFeel': {
    id: 'section.lookAndFeel',
    defaultMessage: 'Look & Feel',
  },
  'section.lookAndFeel.logo': {
    id: 'section.lookAndFeel.logo',
    defaultMessage: 'Logo',
  },
  'section.lookAndFeel.image': {
    id: 'section.lookAndFeel.image',
    defaultMessage: 'Image',
  },
  'section.resizeAndCrop': {
    id: 'section.resizeAndCrop',
    defaultMessage: 'Resize & Crop',
  },
  'section.resizeAndCrop.presets': {
    id: 'section.lookAndFeel.presets',
    defaultMessage: 'Presets',
  },
  'section.resizeAndCrop.presets.original': {
    id: 'section.lookAndFeel.presets.original',
    defaultMessage: 'Original',
  },
  'section.resizeAndCrop.presets.square': {
    id: 'section.lookAndFeel.presets.square',
    defaultMessage: 'Square 1:1',
  },
  'section.resizeAndCrop.presets.landscape-16:9': {
    id: 'section.lookAndFeel.presets.landscape-16:9',
    defaultMessage: 'Landscape 16:9',
  },
  'section.resizeAndCrop.presets.landscape-4:3': {
    id: 'section.lookAndFeel.presets.landscape-4:3',
    defaultMessage: 'Landscape 4:3',
  },
  'section.resizeAndCrop.presets.portrait-9:16': {
    id: 'section.lookAndFeel.presets.portrait-9:16',
    defaultMessage: 'Portrait 9:16',
  },
  'section.resizeAndCrop.presets.portrait-3:4': {
    id: 'section.lookAndFeel.presets.portrait-3:4',
    defaultMessage: 'Portrait 3:4',
  },
  'section.resizeAndCrop.presets.customPreset.addNew': {
    id: 'section.lookAndFeel.presets.customPreset. addNew',
    defaultMessage: 'Add New',
  },
  'section.resizeAndCrop.presets.customPreset.labelPlaceholder': {
    id: 'section.resizeAndCrop.presets.customPreset.labelPlaceholder',
    defaultMessage: 'Label',
  },
  'section.resizeAndCrop.presets.customPreset.widthPlaceholder': {
    id: 'section.resizeAndCrop.presets.customPreset.widthPlaceholder',
    defaultMessage: 'Width',
  },
  'section.resizeAndCrop.presets.customPreset.heightPlaceholder': {
    id: 'section.resizeAndCrop.presets.customPreset.heightPlaceholder',
    defaultMessage: 'Height',
  },
  'section.resizeAndCrop.ratio': {
    id: 'section.lookAndFeel.ratio',
    defaultMessage: 'Ratio',
  },
  'section.resizeAndCrop.ratio.toggleAspectRatio': {
    id: 'section.lookAndFeel.ratio.toggleAspectRatio',
    defaultMessage: 'Allow users to toggle aspect ratio lock',
  },
  'section.resizeAndCrop.ratio.aspectRatioLock': {
    id: 'section.lookAndFeel.ratio.aspectRatioLock',
    defaultMessage: 'Aspect ratio locked by default',
  },
  'section.resizeAndCrop.flipAndRotate': {
    id: 'section.lookAndFeel.flipAndRotate',
    defaultMessage: 'Flip and Rotate',
  },
  'section.resizeAndCrop.flipAndRotate.flip': {
    id: 'section.lookAndFeel.flipAndRotate.flip',
    defaultMessage: 'Show flip buttons',
  },
  'section.resizeAndCrop.flipAndRotate.rotate': {
    id: 'section.lookAndFeel.flipAndRotate.rotate',
    defaultMessage: 'Show rotate buttons',
  },
  'section.imageOverlay': {
    id: 'section.imageOverlay',
    defaultMessage: 'Image Overlay',
  },
  'section.imageOverlay.placementOptions': {
    id: 'section.imageOverlay.placementOptions',
    defaultMessage: 'Placement Options',
  },
  'section.imageOverlay.placementOptions.topLeft': {
    id: 'section.imageOverlay.placementOptions.topLeft',
    defaultMessage: 'Top Left',
  },
  'section.imageOverlay.placementOptions.topRight': {
    id: 'section.imageOverlay.placementOptions.topRight',
    defaultMessage: 'Top Right',
  },
  'section.imageOverlay.placementOptions.bottomLeft': {
    id: 'section.imageOverlay.placementOptions.bottomLeft',
    defaultMessage: 'Bottom Left',
  },
  'section.imageOverlay.placementOptions.bottomRight': {
    id: 'section.imageOverlay.placementOptions.bottomRight',
    defaultMessage: 'Bottom Right',
  },
  'section.imageOverlay.placementOptions.middle': {
    id: 'section.imageOverlay.placementOptions.middle',
    defaultMessage: 'Center',
  },
  'section.textOverlays.presets.heading': {
    id: 'section.textOverlays.presets.heading',
    defaultMessage: 'Heading Georgia, 59',
  },
  'section.textOverlays.presets.subtitle': {
    id: 'section.textOverlays.presets.subtitle',
    defaultMessage: 'Subtitle Arial, 16',
  },
  'section.textOverlays.presets.body': {
    id: 'section.textOverlays.presets.body',
    defaultMessage: 'Body Roboto, 14',
  },
  'section.textOverlays.presets.caption': {
    id: 'section.textOverlays.presets.caption',
    defaultMessage: 'Caption Montserrat, 12',
  },
  'section.export': {
    id: 'section.export',
    defaultMessage: 'Export',
  },
  'section.textOverlays': {
    id: 'section.textOverlays',
    defaultMessage: 'Text Overlays',
  },
  'section.export.quality': {
    id: 'section.export.quality',
    defaultMessage: 'Quality',
  },
  'section.export.quality.auto': {
    id: 'section.export.quality.auto',
    defaultMessage: 'Auto',
  },
  'section.export.quality.best': {
    id: 'section.export.quality.best',
    defaultMessage: 'Best',
  },
  'section.export.quality.good': {
    id: 'section.export.quality.good',
    defaultMessage: 'Good',
  },
  'section.export.quality.eco': {
    id: 'section.export.quality.eco',
    defaultMessage: 'Eco',
  },
  'section.export.quality.low': {
    id: 'section.export.quality.low',
    defaultMessage: 'Low',
  },
  'section.export.formats': {
    id: 'section.export.formats',
    defaultMessage: 'Formats',
  },
  'section.export.actions': {
    id: 'section.export.actions',
    defaultMessage: 'Actions',
  },
  'section.export.actions.showDownloadButton': {
    id: 'section.export.actions.showDownloadButton',
    defaultMessage: 'Show Download Button',
  },
  'section.export.actions.showUrl': {
    id: 'section.export.actions.showUrl',
    defaultMessage: 'Show URL',
  },
  'section.embedCode': {
    id: 'section.embedCode',
    defaultMessage: 'Embed Code',
  },
  'section.embedCode.copyCodeToClipboard': {
    id: 'section.embedCode.copyCodeToClipboard',
    defaultMessage: 'Copy Code to Clipboard',
  },
  'afterExport.tooltipAfterCopy': {
    id: 'afterExport.tooltipAfterCopy',
    defaultMessage: 'Copied',
  },
  'afterExport.info': {
    id: 'afterExport.info',
    defaultMessage: 'You can register to a variety of Media Editor widget events in order to introduce custom behavior in your application, or for analytics tracking once your application is deployed.',
  },
});
